import React, { createContext, useContext, useState, useCallback } from 'react';

// 创建 Context
const DistributionContext = createContext(null);

/**
 * DistributionContext Provider
 * 用于在分销模块组件之间共享刷新功能
 */
export const DistributionContextProvider = ({ children }) => {
    // 存储各个子路由的刷新函数
    const [refreshFunctions, setRefreshFunctions] = useState({});

    // 注册刷新函数
    const registerRefresh = useCallback((routeKey, refreshFn) => {
        setRefreshFunctions((prev) => ({
            ...prev,
            [routeKey]: refreshFn,
        }));

        // 返回取消注册的函数
        return () => {
            setRefreshFunctions((prev) => {
                const newFunctions = { ...prev };
                delete newFunctions[routeKey];
                return newFunctions;
            });
        };
    }, []);

    // 触发指定路由的刷新
    const triggerRefresh = useCallback(
        (routeKey) => {
            const refreshFn = refreshFunctions[routeKey];
            if (refreshFn && typeof refreshFn === 'function') {
                refreshFn();
            }
        },
        [refreshFunctions],
    );

    const value = {
        registerRefresh,
        triggerRefresh,
    };

    return <DistributionContext.Provider value={value}>{children}</DistributionContext.Provider>;
};

/**
 * Hook to use DistributionContext
 */
export const useDistributionContext = () => {
    const context = useContext(DistributionContext);
    if (!context) {
        throw new Error('useDistributionContext must be used within DistributionContextProvider');
    }
    return context;
};
